import type { RootState } from '/business/shared/state/store';
/**
 * Return the basket items/answers.
 */

export default (state: RootState) => state.form?.editingItemKey;
